import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Services", id: "services" },
  { label: "Why Us", id: "veteran" },
  { label: "Contact", id: "contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b ${
        scrolled
          ? "bg-[#0B0E14]/80 backdrop-blur-xl border-white/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="logo-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 group"
        >
          <span className="font-heading font-extrabold text-2xl tracking-tight text-white">
            CYBER<span className="text-[#00FFA3]">VETS</span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-300 hover:text-[#00FFA3] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta"
            onClick={() => scrollTo("contact")}
            className="bg-[#00FFA3] text-[#0B0E14] font-bold px-6 py-3 hover:bg-[#00E5FF] transition-colors text-sm"
          >
            Book a Consultation
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0B0E14]/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="font-mono-tech text-sm uppercase tracking-[0.2em] text-slate-300 hover:text-[#00FFA3] transition-colors text-left"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-nav-cta"
            onClick={() => scrollTo("contact")}
            className="bg-[#00FFA3] text-[#0B0E14] font-bold px-6 py-3 hover:bg-[#00E5FF] transition-colors text-sm"
          >
            Book a Consultation
          </button>
        </div>
      )}
    </nav>
  );
};
